import { useState } from 'react';

interface SpinnerState {
  isLoading: boolean;
  title?: string;
  message?: string;
}

export const useSpinner = () => {
  const [spinnerState, setSpinnerState] = useState<SpinnerState>({
    isLoading: false,
    title: undefined,
    message: undefined,
  });

  const showSpinner = (title?: string, message?: string) => {
    setSpinnerState({
      isLoading: true,
      title,
      message,
    });
  };

  const hideSpinner = () => {
    setSpinnerState({
      isLoading: false,
      title: undefined,
      message: undefined,
    });
  };

  return {
    ...spinnerState,
    showSpinner,
    hideSpinner,
  };
};
